import { runChineseLesson } from '../chinese-lesson';
import type { LearnDoneCallback } from '../app';

/**
 * KP `chinese.phonetic.tone.up` — 三上注音複習（聲調、拼音穩固），
 * a backport so kids entering 三下 can shore up zhuyin fundamentals.
 * Underlying bank: public/data/chinese-zhuyin-review-康軒-三上.json.
 */
export function runChinesePhoneticToneUpLesson(container: HTMLElement, onDone: LearnDoneCallback): Promise<void> {
  return runChineseLesson(container, 'chinese.phonetic.tone.up', onDone);
}
